import { z } from 'zod';
import { dailyDigestInputSchema, pulsePreferenceInputSchema } from '@/domains/settings/lib/shared/settings-input';

export const archiveDatasetSchema = z.enum(['tweets', 'mentions', 'likes', 'bookmarks', 'dms']);

export const searchTimelineToolInputSchema = z.object({
  query: z.string().min(1, 'Query is required'),
  limit: z.number().int().positive().max(100).optional().default(10),
});

export const getTweetToolInputSchema = z.object({
  tweetId: z.string().min(1),
});

export const analyzeTrendsToolInputSchema = z.object({
  timeRange: z.enum(['6h', '12h', '24h', '3d', '7d']).default('24h'),
  limit: z.number().int().positive().optional().default(5),
});

export const compareEngagementToolInputSchema = z.object({
  type: z.enum(['time', 'users']),
  targets: z.array(z.string()).min(1),
});

export const getUserProfileToolInputSchema = z.object({
  username: z.string().min(1),
});

export const getProfileHighlightsToolInputSchema = z.object({}).optional();

export const getArchiveDataToolInputSchema = z.object({
  dataset: archiveDatasetSchema,
  limit: z.number().int().min(1).max(5000).optional(),
  cursor: z.string().min(1).optional(),
  conversationId: z.string().min(1).optional(),
  messageLimit: z.number().int().min(1).max(300).optional(),
});

export const getImportStatusToolInputSchema = z.object({}).optional();

export const setDailyDigestPreferenceToolInputSchema = dailyDigestInputSchema.optional();

export const setPulsePreferenceToolInputSchema = pulsePreferenceInputSchema.optional();

export type ArchiveDataset = z.infer<typeof archiveDatasetSchema>;
export type SearchTimelineToolInput = z.infer<typeof searchTimelineToolInputSchema>;
export type GetTweetToolInput = z.infer<typeof getTweetToolInputSchema>;
export type AnalyzeTrendsToolInput = z.infer<typeof analyzeTrendsToolInputSchema>;
export type CompareEngagementToolInput = z.infer<typeof compareEngagementToolInputSchema>;
export type GetUserProfileToolInput = z.infer<typeof getUserProfileToolInputSchema>;
export type GetProfileHighlightsToolInput = z.infer<typeof getProfileHighlightsToolInputSchema>;
export type GetArchiveDataToolInput = z.infer<typeof getArchiveDataToolInputSchema>;
export type GetImportStatusToolInput = z.infer<typeof getImportStatusToolInputSchema>;
export type SetDailyDigestPreferenceToolInput = z.infer<typeof setDailyDigestPreferenceToolInputSchema>;
export type SetPulsePreferenceToolInput = z.infer<typeof setPulsePreferenceToolInputSchema>;
